export default __webpack_public_path__ + "static/media/CDC_de.a9cc26f7.svg";